// Cart.js
import React, { useState } from "react";
import { useCart } from "./CartContext";
import MpesaPayment from "../Mpesa/MpesaPayment"

function Cart({ isOpen, onClose }) {
  const {
    cartItems,
    removeFromCart,
    totalPrice,
  } = useCart();

  const [showPayment, setShowPayment] = useState(false);

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white text-black w-96 p-6 rounded-xl shadow-lg relative">
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-gray-600 hover:text-black text-lg font-bold"
          >
            ×
          </button>
          <h2 className="text-xl font-bold mb-4">🛒 Your Cart</h2>

          {cartItems.length === 0 ? (
            <p className="text-center">No bots in the cart.</p>
          ) : (
            <>
              <ul className="space-y-3 max-h-72 overflow-y-auto pr-2">
                {cartItems.map((item) => (
                  <li
                    key={item.id}
                    className="flex justify-between items-center border-b pb-1"
                  >
                    <div>
                      <p className="font-semibold">{item.heading}</p>
                      <p className="text-sm text-gray-600">
                        Ksh {item.price} × {item.quantity} ={" "}
                        <strong>Ksh {item.price * item.quantity}</strong>
                      </p>
                    </div>
                    <button
                      className="bg-red-600 hover:bg-red-500 text-white px-2 py-1 rounded text-sm"
                      onClick={() => removeFromCart(item.id)}
                    >
                      −
                    </button>
                  </li>
                ))}
              </ul>

              <div className="mt-4 text-lg font-semibold">
                Total: <span className="text-green-600">Ksh {totalPrice}</span>
              </div>

              <button
                onClick={() => setShowPayment(true)}
                className="mt-4 w-full bg-blue-600 hover:bg-blue-500 text-white py-2 rounded-lg"
              >
                Purchase All via M-Pesa
              </button>
            </>
          )}
        </div>
      </div>

      <MpesaPayment
        show={showPayment}
        onClose={() => setShowPayment(false)}
        isCartPurchase={true}
      />
    </>
  );
}

export default Cart;
